import { StyleSheet } from 'react-native';
import { fontFamilyBold } from '../../constants/palette';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
  },
  title: {
    // fontSize: 20,
    fontFamily: fontFamilyBold,
    // fontWeight: 'bold',
    marginBottom: 10,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
});

export default styles;
